// Components
export {
  registerBrush,
  registerScrollBar,
  registerTitle,
  registerTooltip,
  registerCartesianBandAxis,
  registerCartesianCrossHair,
  registerCartesianLinearAxis,
  registerCartesianLogAxis,
  registerCartesianSymlogAxis,
  registerCartesianTimeAxis,
  registerContinuousLegend,
  registerCustomMark,
  registerDataZoom,
  registerDiscreteLegend,
  registerGeoCoordinate,
  registerIndicator,
  registerLabel,
  registerTotalLabel,
  registerMarkLine,
  registerMarkArea,
  registerMarkPoint,
  registerPolarMarkLine,
  registerPolarMarkArea,
  registerPolarMarkPoint,
  registerGeoMarkPoint,
  registerPlayer,
  registerPolarBandAxis,
  registerPolarCrossHair,
  registerPolarLinearAxis,
  registerPoptip
} from '@visactor/vchart';

export {
  registerMapLabel,
  registerAxis3dPlugin,
  registerBar3dChart,
  registerFunnel3dChart,
  registerHistogram3dChart,
  registerPie3dChart,
  registerRangeColumn3dChart,
  registerWordCloud3dChart,
  registerPictogramChart
} from '@visactor/vchart-extension';

// Charts
export {
  registerLineChart,
  registerAreaChart,
  registerBarChart,
  registerBoxplotChart,
  registerCirclePackingChart,
  registerCircularProgressChart,
  registerCommonChart,
  registerFunnelChart,
  registerGaugeChart,
  registerHeatmapChart,
  registerHistogramChart,
  registerLinearProgressChart,
  registerMapChart,
  registerPieChart,
  registerRadarChart,
  registerRangeAreaChart,
  registerRangeColumnChart,
  registerRoseChart,
  registerSankeyChart,
  registerScatterChart,
  registerSequenceChart,
  registerSunburstChart,
  registerTreemapChart,
  registerWaterfallChart,
  registerWordCloudChart,
  registerCorrelationChart,
  registerLiquidChart,
  registerWordCloudShapeChart,
  registerVennChart,
  registerMosaicChart
} from '@visactor/vchart';

// Plugins
export { registerChartResizeZoomPlugin } from '@visactor/vchart';
